import {
  brandSpecificStaticText,
  staticText,
  Translated,
} from '../../utils/translations/staticText';

// Block ships only on SingSaver (SG, EN) and MoneyHero (HK, EN + ZH-HK) per
// CMS-1724. SingSaver has no ZH locale, so the default (`_`) covers it;
// MoneyHero overlays ZH-HK on the same English defaults.
//
// The subtitle interpolates the number of tiers via the `:count` marker
// (Figma node 21471:41978). PlanTierSelector substitutes it with the rendered
// tier count, so the copy stays correct for any number of tiers.
export const TRANSLATIONS = brandSpecificStaticText({
  _: staticText({
    heading: { _: 'Choose your plan' },
    subheading: { _: ':count tiers, ordered cheapest to most comprehensive.' },
  }),
  moneyhero: staticText({
    heading: { _: 'Choose your plan', zh: '選擇您的方案' },
    subheading: {
      _: ':count tiers, ordered cheapest to most comprehensive.',
      zh: ':count個等級，從最便宜到最全面排序。',
    },
  }),
});

export type StaticText = Translated<typeof TRANSLATIONS>;

// Copy the block renders for the tier cards + desktop summary panel (CMS-1724 /
// CMS-1864). Resolved inside the block (PlanTierSelector / PlanTierSummaryPanel)
// via `useCmsClientContext`, exactly like `TRANSLATIONS` above — the wrapper
// passes raw data and never touches these, so all PlanTierSelector copy both
// lives and is resolved in cms-components. The one exception is
// `noProductsAvailable`, rendered by the fe-services wrapper's own no-products
// banner (TISearchBanner), so the wrapper resolves that single key.
// The block is brand-gated to SingSaver (EN) + MoneyHero (EN + ZH-HK), so the
// `_` default + a `zh` override cover every locale that can reach it.
//
// Markers interpolated by `tr` at the call site: :percent / :zhe (discount),
// :brand (highlight), :count (traveller counts), :travellers (family wrap).
// ZH discount uses the 折 (zhe) convention, e.g. 50% off → 享5折優惠.
export const CONTENT_TRANSLATIONS = staticText({
  applyNow: { _: 'Apply Now', zh: '立即申請' },
  discountOff: { _: ':percent% off', zh: '享:zhe折優惠' },
  perTrip: { _: 'trip', zh: '次旅行' },
  perYear: { _: 'year', zh: '年' },
  noProductsAvailable: { _: 'No products available', zh: '暫無可用產品' },
  discountHighlight: {
    _: 'Only with :brand you get :percent% off',
    zh: '只限 :brand，尊享 :percent% 折扣',
  },
  coverType: { _: 'Cover Type', zh: '保障類型' },
  coverTypeSingle: { _: 'Single-Trip', zh: '單次計劃' },
  coverTypeAnnual: { _: 'Annual', zh: '全年旅程' },
  destination: { _: 'Destination', zh: '目的地' },
  startDate: { _: 'Start Date', zh: '開始日期' },
  endDate: { _: 'End Date', zh: '結束日期' },
  travellers: { _: 'Travellers', zh: '旅客人數' },
  adultOne: { _: '1 Adult', zh: '1位成人' },
  adultsMany: { _: ':count Adults', zh: ':count位成人' },
  childOne: { _: '1 Child', zh: '1位兒童' },
  childrenMany: { _: ':count Children', zh: ':count位兒童' },
  familyWrap: { _: 'Family (:travellers)', zh: '家庭（:travellers）' },
  listSeparator: { _: ', ', zh: '，' },
});
